const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  if (!deps || deps.length === 0) {
    return baseModule();
  }
  const links = document.getElementsByTagName("link");
  return Promise.all(deps.map((dep) => {
    dep = assetsURL(dep, importerUrl);
    if (dep in seen)
      return;
    seen[dep] = true;
    const isCss = dep.endsWith(".css");
    const cssSelector = isCss ? '[rel="stylesheet"]' : "";
    const isBaseRelative = !!importerUrl;
    if (isBaseRelative) {
      for (let i = links.length - 1; i >= 0; i--) {
        const link2 = links[i];
        if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
          return;
        }
      }
    } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
      return;
    }
    const link = document.createElement("link");
    link.rel = isCss ? "stylesheet" : scriptRel;
    if (!isCss) {
      link.as = "script";
      link.crossOrigin = "";
    }
    link.href = dep;
    document.head.appendChild(link);
    if (isCss) {
      return new Promise((res, rej) => {
        link.addEventListener("load", res);
        link.addEventListener("error", () => rej(new Error(`Unable to preload CSS for ${dep}`)));
      });
    }
  })).then(() => baseModule()).catch((err) => {
    const e = new Event("vite:preloadError", { cancelable: true });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  });
};
const listen = (el, event, handler) => {
  if (!el)
    return () => {
    };
  el.addEventListener(event, handler);
  return () => el.removeEventListener(event, handler);
};
const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
const qs = (selector, root = document) => root.querySelector(selector);
const add = (el, className) => {
  var _a;
  return (_a = el == null ? void 0 : el.classList) == null ? void 0 : _a.add(className);
};
const remove = (el, className) => {
  var _a;
  return (_a = el == null ? void 0 : el.classList) == null ? void 0 : _a.remove(className);
};
const contains = (el, className) => {
  var _a;
  return (_a = el == null ? void 0 : el.classList) == null ? void 0 : _a.contains(className);
};
const selectors = {
  sliderContainer: ".swiper",
  visibleSlides: ".swiper-slide-visible"
};
const classes = {
  overflow: "has-overflow",
  carousel: "carousel"
};
const Carousel = (node, options = {}) => {
  const swiperContainer = contains(node, classes.carousel) ? node : qs(selectors.sliderContainer, node);
  if (!swiperContainer)
    return;
  let carousel;
  const events = [];
  const defaultSwiperOptions = {
    slidesPerView: 2,
    grabCursor: true,
    preloadImages: false,
    watchSlidesProgress: true,
    on: {
      init: function() {
        handleOverflow(this.slides);
      },
      breakpoint: function() {
        onBreakpointChange(this.slides);
      }
    }
  };
  const nextButton = qs("[data-next]", node);
  const prevButton = qs("[data-prev]", node);
  const useNav = nextButton && prevButton;
  const handleOverflow = (slides) => {
    setTimeout(() => {
      const hasOverflow = contains(swiperContainer, classes.overflow);
      const needsOverflow = qsa(selectors.visibleSlides, swiperContainer).length !== slides.length;
      if (!hasOverflow && needsOverflow) {
        add(swiperContainer, classes.overflow);
      } else if (hasOverflow && !needsOverflow) {
        remove(swiperContainer, classes.overflow);
      }
    }, 0);
  };
  const onBreakpointChange = (slides) => {
    handleOverflow(slides);
  };
  function handleFocus(event) {
    const slide = event.target.closest(".swiper-slide");
    const allSlides = [...slide.parentElement.children];
    const slideIndex = allSlides.indexOf(slide);
    if (document.body.classList.contains("user-is-tabbing")) {
      carousel.slideTo(slideIndex);
    }
  }
  __vitePreload(() => import("./swiper-a8eb4a5b.js").then((n) => n.s), true ? [] : void 0, import.meta.url).then(({ Swiper, Navigation, Pagination, Scrollbar }) => {
    let swiperOptions = Object.assign(defaultSwiperOptions, options);
    let modules = [];
    if ("navigation" in swiperOptions) {
      modules.push(Navigation);
    } else if (useNav) {
      modules.push(Navigation);
      swiperOptions.navigation = {
        nextEl: nextButton,
        prevEl: prevButton
      };
    }
    if ("pagination" in swiperOptions) {
      modules.push(Pagination);
    }
    if ("scrollbar" in swiperOptions) {
      modules.push(Scrollbar);
    }
    if (modules.length > 0) {
      swiperOptions.modules = modules;
    }
    carousel = new Swiper(swiperContainer, swiperOptions);
    events.push(listen(swiperContainer, "focusin", handleFocus));
  });
  return {
    destroy: () => {
      carousel == null ? void 0 : carousel.destroy();
      events.forEach((unsubscribe) => unsubscribe());
    }
  };
};
export {
  Carousel as C
};
